import React, { useRef }  from "react";
import { connect } from "react-redux";
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { QRCodeCanvas } from 'qrcode.react';
import Card from "components/card";
import { Form, Image } from 'antd';
import FormItem from "components/fields/FormItem";
import { renderLabel, displayFullName, displayAddress, displayFarmNameLocation } from '../../../../utils/index';
import Lineage from "./Lineage";
import DALogo from "../../../../assets/img/DA_logo.png";
import BagongPilipinasLogo from "../../../../assets/img/Bagong-Pilipinas-Logo.png";
import Button from "components/button";
import { APP_URL } from "services/authheader";
//import { useReactToPrint } from 'react-to-print';

const PedigreeCertificate = ({lineage, recordData, ...props}) => {
	
	const qrCodeData = `${APP_URL}/certificate/record/${recordData.id}/${recordData.tag_id}`;

	const componentRef = useRef();

    // const handlePrint = useReactToPrint({
    //     content: () => componentRef.current,
    // });

	const handleDownloadPdf = async () => {
		if (!componentRef.current) {
			console.error("Component reference is not available");
			return;
		}
	
		const element = componentRef.current;
		const canvas = await html2canvas(element, { scale: window.devicePixelRatio });
		const imgData = canvas.toDataURL("image/png");
		
		const pdf = new jsPDF("p", "mm", "a4");
		const pdfWidth = pdf.internal.pageSize.getWidth();

    	const imgHeight = pdf.internal.pageSize.getHeight();
		const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
	
		if (pdfHeight > imgHeight) {
			let pageHeightLeft = pdfHeight;

			while (pageHeightLeft > 0) {
				pdf.addImage(imgData, "PNG", 0, pageHeightLeft - pdfHeight, pdfWidth, pdfHeight);
				pageHeightLeft -= imgHeight;
				if (pageHeightLeft > 0) {
					pdf.addPage();
				}
			}
		} else {
			pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
		}
	
		pdf.save(`${recordData?.tag_id}_certificate.pdf`);
	};

	return (
		<div>
			<div ref={componentRef} className="p-4">
			<Form className="form" layout="vertical">
				<div className="flex justify-center mb-5">
					<div className="w-[150px] p-6">
						<Image width="100%" src={DALogo} preview={false}/>
					</div>
					<h1 className="font-umaguntia text-[40px] text-center mt-10 mx-10">Certificate of Registration</h1>
					<div className="w-[150px]">
						<Image width="100%" src={BagongPilipinasLogo} preview={false}/>
					</div>
				</div>

				<div className="form-column-4">
					<FormItem label="Tag ID">
						{renderLabel(recordData?.tag_id)}
					</FormItem>

					<FormItem label="Type">
						{renderLabel(recordData?.type?.name)}                
					</FormItem>

					<FormItem label="Breed">
						{renderLabel(recordData?.breed?.name)}                
					</FormItem>

					<FormItem label="Gender">
						{renderLabel(recordData?.gender?.name)}                
					</FormItem>

					<FormItem label="Date of Birth">
						{renderLabel(recordData?.date_of_birth)}                
					</FormItem>

					<FormItem label="Birth Type">
						{renderLabel(recordData?.birth_type?.name)}                
					</FormItem>

					<FormItem label="Horn Status">
						{renderLabel(recordData?.horn_status?.name)}                
					</FormItem>

					<FormItem label="Color">
						{renderLabel(recordData?.color)}                
					</FormItem>

					<FormItem label="Sire ID">
						{renderLabel(recordData?.sire?.tag_id)}                
					</FormItem>

					<FormItem label="Dam ID">
						{renderLabel(recordData?.dam?.tag_id)}                
					</FormItem>

					<FormItem extra="col-span-1 md:col-span-2"
						label="Farm / Location"
					>
						{renderLabel(displayFarmNameLocation(recordData?.farm))}					
					</FormItem>
					
					<FormItem extra="col-span-1 md:col-span-3 xl:col-span-4"
						label="Notes or Remarks"
					>
						{renderLabel(recordData?.remarks)}					
					</FormItem>
				</div>
				<div className="form-column-3">
					<FormItem label="QR Code">
						<QRCodeCanvas value={qrCodeData} size={100}/>      
					</FormItem>
					
					<FormItem label="Breeder">
						{renderLabel(recordData?.farm?.account?.name, 'block font-bold')}
						{renderLabel(recordData?.farm?.name, 'block')}
						{renderLabel(displayAddress(recordData?.farm?.address), 'block')}
					</FormItem>

					<FormItem label="Current Owner">
						{renderLabel(recordData?.farm?.account?.name, 'block font-bold')}
						{renderLabel(recordData?.farm?.name, 'block')}  
						{renderLabel(displayAddress(recordData?.farm?.address), 'block')}
					</FormItem>
				</div>

				<div className="flex certificate">
					<div className="flex flex-row-reverse gap-10">
						<Lineage recordData={lineage} type="data"/>
					</div>
				</div>
			</Form>
			</div>

			<div className="dark:bg-intsamis-900 text-right mt-3">
				{/* <Button className="btn-primary me-3" onClick={handlePrint}>
					Print
				</Button> */}
				<Button className="btn-primary" onClick={handleDownloadPdf}>
					Download as PDF
				</Button>
			</div>
		</div>
		
    );
};

const mapStateToProps = (state) => ({
	recordData: state.farmAnimal.details?.data,
	lineage: state.farmAnimal.lineage?.data,
});

const mapDispatchToProps = (dispatch) => ({
	
});

export default connect(mapStateToProps, mapDispatchToProps)(PedigreeCertificate);